// src/Dashboard/pages/user/FicheAdherent/components/AdherentTabContent.jsx

import React from "react";

import AdherentDetails from "../../../../../pages/PagesAdministrateurs/DetailsAdherent/AdherentDetails";
import AdherentGroupCategory from "../../../../../pages/PagesAdministrateurs/DetailsAdherent/AdherentGroupCategory";
import AdherentManagers from "../../../../../pages/PagesAdministrateurs/DetailsAdherent/AdherentManagers";
import AdherentPassageCeinture from "../../../../../pages/PagesAdministrateurs/DetailsAdherent/AdherentPassageCeinture";
import AdherentPalmares from "../../../../../pages/PagesAdministrateurs/DetailsAdherent/AdherentPalmares";
import AdherentCompetitions from "../../../../../pages/PagesAdministrateurs/DetailsAdherent/AdherentCompetitions";
import DossierInscription from "../../../../../pages/PagesAdministrateurs/DetailsAdherent/DossierInscription";
import ReglementInscription from "../../../../../pages/PagesAdministrateurs/DetailsAdherent/ReglementInscription";
import AchatsAdherent from "../../../../../pages/PagesAdministrateurs/DetailsAdherent/AchatsAdherent";
import AttendanceList from "../../../../../pages/PagesAdministrateurs/DetailsAdherent/AttendanceList";

function TabShell({ title, description, children }) {
  return (
    <section className="rounded-[24px] border border-slate-200 bg-slate-50 p-3 dark:border-slate-800 dark:bg-slate-900/60 sm:p-4">
      <div className="mb-4 rounded-2xl bg-white p-4 shadow-sm dark:bg-slate-950">
        <h3 className="text-lg font-bold text-slate-900 dark:text-white">
          {title}
        </h3>
        {description && (
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            {description}
          </p>
        )}
      </div>

      {children}
    </section>
  );
}

export default function AdherentTabContent({
  activeTab,
  adherent,
  adherentId,
  onEdit,
}) {
  if (!adherent || !adherentId) {
    return null;
  }

  switch (activeTab) {
    case "profil":
      return (
        <TabShell
          title="Profil adhérent"
          description="Informations personnelles, coordonnées, licence et notes visibles."
        >
          <AdherentDetails
            adherent={adherent}
            showTeacherNotes={false}
            onEdit={onEdit}
          />
        </TabShell>
      );

    case "groupes":
      return (
        <TabShell
          title="Groupes & catégories"
          description="Groupes de pratique, catégorie d’âge, catégorie de poids et licence."
        >
          <AdherentGroupCategory adherentId={adherentId} />
        </TabShell>
      );

    case "gestionnaires":
      return (
        <TabShell
          title="Gestionnaires liés"
          description="Utilisateurs rattachés à cet adhérent."
        >
          <AdherentManagers adherentId={adherentId} />
        </TabShell>
      );

    case "ceintures":
      return (
        <TabShell
          title="Passages de ceintures"
          description="Historique des grades et diplômes disponibles."
        >
          <AdherentPassageCeinture adherentId={adherentId} />
        </TabShell>
      );

    case "competitions":
      return (
        <TabShell
          title="Compétitions"
          description="Inscriptions, participations et informations liées aux compétitions."
        >
          <AdherentCompetitions adherentId={adherentId} />
        </TabShell>
      );

    case "palmares":
      return (
        <TabShell
          title="Palmarès"
          description="Résultats, classements et observations."
        >
          <AdherentPalmares adherentId={adherentId} />
        </TabShell>
      );

    case "dossier":
      return (
        <TabShell
          title="Dossier d’inscription"
          description="Certificat médical, licence, règlement et documents liés."
        >
          <DossierInscription adherentId={adherentId} />
        </TabShell>
      );

    case "reglement":
      return (
        <TabShell
          title="Règlement d’inscription"
          description="Suivi des paiements et de la situation financière de l’inscription."
        >
          <ReglementInscription
            adherentId={adherentId}
            saison={adherent.saison_active}
          />
        </TabShell>
      );

    case "achats":
      return (
        <TabShell
          title="Achats"
          description="Articles, commandes ou achats liés à cet adhérent."
        >
          <AchatsAdherent adherentId={adherentId} />
        </TabShell>
      );

    case "presences":
      return (
        <TabShell
          title="Présences & absences"
          description="Historique des présences par mois."
        >
          <AttendanceList adherentId={adherentId} />
        </TabShell>
      );

    default:
      return null;
  }
}